import UIButton from 'UIComponents/button/UIButton';
import styled, { css } from 'foundations-theming-specialty/utils';
import { BREEZE_SPECIAL } from '../../../../constants/BreezeUse';
const DropdownButtonIconStyle = css([".uiDropdown__buttonContents{display:inline-block;.uiDropdown__buttonLabel{margin-right:", ";}}[class^='AbstractDropdown']{display:inline;[class^='DropdownCaret']{margin-left:", ";}}"], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['200']);
const IconStyle = css([".ai-icon{position:relative;bottom:", ";}"], ({
  theme
}) => theme.space['25']);
export const BreezePrimaryAIBaseButton = styled(UIButton).withConfig({
  displayName: "StyledAIBaseButton__BreezePrimaryAIBaseButton",
  componentId: "sc-6opn7o-0"
})(["border-radius:", " !important;color:", " !important;border:none !important;background:", " !important;&:hover{background-color:", " !important;}&:active{background-color:", " !important;}", " ", " &&&{", " &.disabled{color:", " !important;border-color:", " !important;}}"], ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['breeze-fill-primary-default'], ({
  theme
}) => theme.color['breeze-fill-primary-hover'], ({
  theme
}) => theme.color['breeze-fill-primary-pressed'], DropdownButtonIconStyle, IconStyle, ({
  $cssStyles
}) => $cssStyles, ({
  theme
}) => theme.color['text-core-disabled'], ({
  theme
}) => theme.color['border-core-subtle-pressed']);
export const BreezeSecondaryAIBaseButton = styled(UIButton).withConfig({
  displayName: "StyledAIBaseButton__BreezeSecondaryAIBaseButton",
  componentId: "sc-6opn7o-1"
})(["border-radius:", " !important;color:", " !important;border-color:", " !important;background:", " !important;&:hover{color:", " !important;border-color:", " !important;background:", " !important;}&:active{color:", " !important;border-color:", " !important;background:", " !important;}", " ", " &&&{", " &.disabled{color:", " !important;border-color:", " !important;}}"], ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => theme.color['breeze-fill-primary-default'], ({
  theme
}) => theme.color['breeze-border-field-default'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['breeze-fill-primary-hover'], ({
  theme
}) => theme.color['breeze-fill-primary-hover'], ({
  theme
}) => theme.color['breeze-fill-secondary-hover'], ({
  theme
}) => theme.color['breeze-fill-primary-pressed'], ({
  theme
}) => theme.color['breeze-fill-primary-pressed'], ({
  theme
}) => theme.color['breeze-fill-secondary-pressed'], DropdownButtonIconStyle, IconStyle, ({
  $cssStyles
}) => $cssStyles, ({
  theme
}) => theme.color['text-core-disabled'], ({
  theme
}) => theme.color['border-core-subtle-pressed']);
export const BreezeTertiaryAIBaseButton = styled(UIButton).withConfig({
  displayName: "StyledAIBaseButton__BreezeTertiaryAIBaseButton",
  componentId: "sc-6opn7o-2"
})(["border-radius:", " !important;color:", " !important;border-color:", " !important;background:", " !important;&:hover{color:", " !important;border-color:", " !important;}&:active{color:", " !important;border-color:", " !important;}", " ", " &&&{", " &.disabled{color:", " !important;border-color:", " !important;}}"], ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['fill-accent-neutral-hover'], ({
  theme
}) => theme.color['fill-accent-neutral-hover'], ({
  theme
}) => theme.color['fill-accent-neutral-pressed'], ({
  theme
}) => theme.color['fill-accent-neutral-pressed'], DropdownButtonIconStyle, IconStyle, ({
  $cssStyles
}) => $cssStyles, ({
  theme
}) => theme.color['text-core-disabled'], ({
  theme
}) => theme.color['border-core-subtle-pressed']);
export const BreezeSpecialAIBaseButton = styled(UIButton).withConfig({
  displayName: "StyledAIBaseButton__BreezeSpecialAIBaseButton",
  componentId: "sc-6opn7o-3"
})(["border-radius:", " !important;&:not(.disabled){background:", " !important;color:", " !important;border:none !important;&:hover{background:", ";}&:active{background:", ";}&.disabled{background:none;}}", " ", " &&&{", " &.disabled{color:", " !important;border-color:", " !important;}}"], ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => theme.color['breeze-fill-special-btn-alt-default'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['breeze-fill-primary-hover'], ({
  theme
}) => theme.color['breeze-fill-primary-pressed'], DropdownButtonIconStyle, IconStyle, ({
  $cssStyles
}) => $cssStyles, ({
  theme
}) => theme.color['text-core-disabled'], ({
  theme
}) => theme.color['border-core-subtle-pressed']);
export const BreezeTransparentAIBaseButton = styled(UIButton).withConfig({
  displayName: "StyledAIBaseButton__BreezeTransparentAIBaseButton",
  componentId: "sc-6opn7o-4"
})(["border-radius:", " !important;border:none !important;color:", " !important;&:not(.disabled) .ai-icon,&:not(.disabled) span{color:", " !important;}&:hover{color:", " !important;}&:active{color:", " !important;}", " ", " &&&{", " &.disabled{color:", " !important;border-color:", " !important;}}"], ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => theme.color['breeze-fill-primary-default'], ({
  theme
}) => theme.color['breeze-fill-primary-default'], ({
  theme
}) => theme.color['breeze-fill-primary-hover'], ({
  theme
}) => theme.color['breeze-fill-primary-pressed'], DropdownButtonIconStyle, IconStyle, ({
  $cssStyles
}) => $cssStyles, ({
  theme
}) => theme.color['text-core-disabled'], ({
  theme
}) => theme.color['border-core-subtle-pressed']);
export const getStyledAIButton = use => {
  switch (use) {
    case BREEZE_SPECIAL:
      return BreezeSpecialAIBaseButton;
    case 'primary':
      return BreezePrimaryAIBaseButton;
    case 'secondary':
      return BreezeSecondaryAIBaseButton;
    case 'tertiary':
      return BreezeTertiaryAIBaseButton;
    case 'transparent':
      return BreezeTransparentAIBaseButton;
    default:
      return BreezePrimaryAIBaseButton;
  }
};